<template>
  <div class="main-con el-main">
    <nav-breadcrumb :menu="[{label: '明细报表'}]"/>
    <el-row class="xzpadd10 bg-purple">
      <data-table
        :tableData="listData"
        :columns="listColumns"
        :pageSize.sync="pageSize"
        :page.sync="page"
        :filters="filters"
        :actions="actions"
      ></data-table>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../../filters/Status2CN";
  import {xmlBuildQuery} from "../../../filters/CommonActions";
  import {formatMoney} from "../../../filters/CommonFilters";
    export default {
        name: "ReportingFinanceList",
      data() {
        return {
          transactionStatus: this.$route.query['fi.transactionStatus'],
          page: 1,
          pageSize: 10,
          listData: {},
          listColumns: [
            {
              name: '序号',
              type: 'index'
            },
            {
              name: '贷款编号',
              field: 'fi__transactionNo'
            },
            {
              name: '客户姓名',
              field: 'u__customerName'
            },
           /* {
              name: '手机号',
              field: 'i__contactTelNo'
            },*/
            {
              name: '授信额度',
              field: 'cr__lineOfCredit',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              name: '授信期限',
              field: 'cr__creditValidity',

            },

            {
              name: '贷款金额(元)',
              field: 'fi__totalAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              name: '占用额度',
              field: 'bal__principalAmount',
              formatter: function (r,c,v) {
                return formatMoney(r.cr__lineOfCredit-r.cr__creditBalance)
              }
            },
            {
              name: '可用额度',
              field: 'cr__creditBalance',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              name: '贷款利率（%）',
              field: 'fi__interestRate'
            },
            {
              name: '申请日期',
              field: 'fi__transactionDate'
            },

            {
              name: '放款时间',
              field: 'pay__payDate',
              formatter: function (r,c,v) {
                if(v)
                return moment(v).format('YYYY-MM-DD HH:mm:ss')
              }
            },
            {
              name: '到期日',
              field: 'fi__endDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD')
              }
            },
            {
              name: '放款流水号',
              field: 'pay__reference'
            },

            {
              name: '还款时间',
              field: 'rpay__repayDate',
              formatter: function (r,c,v) {
                if(v)
                return moment(v).format('YYYY-MM-DD  HH:mm:ss')
              }
            },

            {
              name: '还款流水号',
              field: 'rpay__reference'
            },

            {
              name: '还款金额',
              field: 'rpay__totalAmount',
              formatter: function (r,c,v) {
                if(v)
                return formatMoney(v)
              }
            },

            {
              name: '还款方式',
              field: 'rpay__channel',
              formatter: function (r,c,v) {
                return Status2CN(v)
              }
            },

            {
              name: '还款备注',
              field: 'cj__remarks'
            },

          ],
          filters: {
            form: {
              fi__endDate: [],
            },
            columns: [
              {
                label: '放款时间',
                component: 'date-range-picker',
                field: 'fi__transactionDate',

              },
            ],
            onSubmit:()=>{
              this.page = 1
              this.getReportingFinanceList()
            }
          },

          actions: [
            {
              label: '导出',
              class: 'el-icon-download el-button--primary',
              clickHandler:()=>{
                let routeData = this.$router.resolve({
                  path: '/ix/reporting/Financing.List?format=xlsx',
                  query: Object.assign({}, this.filterParams, xmlBuildQuery(this.filters))
                });
                window.open(routeData.href.replace('#/', '/'), '_blank');
              }
            }
          ]
        }
      },
      computed : {
        filterParams: {
          get: function() {
            return {
              pageSize: this.pageSize,
              pageOffset: (this.page - 1) * this.pageSize,
              // 'xlist.sort.dataField': 'fi.transactionDate',
              // 'xlist.sort.order': 'desc'
            }
          },
          set:function (newVal) {

          }
        }
      },
      watch: {
        filterParams: function () {
          this.getReportingFinanceList()
        }
      },
      mounted() {

      },
      methods: {
        getReportingFinanceList: function () {
          xhr.getReportingFinanceList(
            Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
            res=> {
              try {
                this.listData = res.data
              }catch(e){

              }
            })

        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/Reporting/ReportingFinanceList.vue